import axios from 'axios';
import store from '../../src/store/store.js'
import GO1_API from '../../src/config/api'

export default {

    // determine if user has a active session
    hasSession() {
        return store.state.auth_session !== null;
    },

    // get session
    getSession() {
        return store.state.auth_session;
    },

    hasError() {
        return store.state.error_message !== null;
    },

    // get Bearer Token Auth config for axios requests
    getAPIAuthConfig() {
        return {
            headers: {
                Authorization: `Bearer ${this.getSession().jwt}`
            }
        }
    },

    // login to go1 with credentials, save session in Vuex
    login(credentials) {
        const backendUrl = process.env.BACKEND_URL || '';
        const postData = Object.assign({csrf_token: store.state.csrf_token}, credentials);
        return axios.post(`${backendUrl}/login`, postData)
            .then(resp => {
                store.commit("login", resp.data);
                return resp.data;
            });
    },

    // delete session
    logout() {
        store.commit("logout");
    },

    // create new user/portal
    register(credentials) {
        // registrations coming from Totara will be handled the old way for the time being ;)
        if (store.state.client_id === 'totara') {
            return axios.post(`${GO1_API}onboard-service/portal`, credentials);
        }

        return axios.post(`${GO1_API}onboard2-service/portal?x-expensive=1`, credentials);
    },

    // check if user is authorized and has a JWT session before going to routes that need it
    guard(to, from, next, shouldBeAuth) {
        // user is already logged in but is trying to go to an unauthorized route
        if (this.hasError()) {
            next({name: 'error'})
        } else if (!shouldBeAuth && this.hasSession()) {
            next({name: 'portals'})
        } else if (shouldBeAuth && !this.hasSession()) {
            // user isn't logged in and is trying to go to an authorized route
            next({name: 'login'})
        } else {
            // valid destination based on authorization of the route and the user's session status
            next()
        }
    },

    getAuthorizeIdpUrl(provider, identityGroup, redirectUrl) {
        return `${GO1_API}sso/oauth/${provider}/authorize?identity_group=${identityGroup}&login_redirect_url=${redirectUrl}`;
    },

    /**
     * Send a POST request to /oauth/authorize passing the redirect=false, so a non-redirect response will be returned.
     *
     * @param payload
     * @returns {AxiosPromise<any>}
     */
    authorizeWithoutRedirect(payload) {
        const backendUrl = process.env.BACKEND_URL || '';

        return axios.post(`${backendUrl}/oauth/authorize?redirect=false`, payload);
    }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js